import { StFeatureFlagFlags } from '@/plugins/rollout';

export default {
  ...StFeatureFlagFlags
};
